import styled from 'styled-components/macro'
import { Icon } from '@scuf/common'

const AddIcon = styled(Icon)`
cursor: pointer;
`
export {
  AddIcon
}
